import React from "react";
import { Title } from "../../../../../stories/Title/Title";
import { LabelProps } from "../../../../../utils/types";
import { TextField } from "@mui/material";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../../stories/Button/Button";
import OpenIcon from "../../../../../images/OpenIcon.svg";
import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import { handleMUISelectEvent } from "../../../../../utils/UtilFunctions";
import { NavTypeProps } from "../ItemsList";
import Navbar from "../../../../common/layout/Navbar";
import useLabels from "../../../../../customHooks/useLabels";
import useFormJson from "../../../../../json/useFormJson";
const groupOptions = [
  "IT Equipment (IT001)",
  "Tools and Machinery",
  "Softwares",
];

const ItemIndividualList = ({ NavType }: NavTypeProps) => {
  const navigate = useNavigate();
  const {itemLabel}=useLabels();
  const{ItemObForm}=useFormJson();
  return (
    <>
      <Navbar NavType={NavType} />
      <Title>{itemLabel} - OB Individual</Title>
      <div className="item-individual">
        <div className="item-ob__entry--select">
          <div className="item-ob__entry--select--grid">
            {ItemObForm.ObDetails.map((res: LabelProps, index: React.Key) => {
              if (res.labelName === "Code") {
                return (
                  <div className="item-ob__entry--select--flex">
                    <LabeledAutocomplete
                      className={labelClasses.inputRoot}
                      onKeyDown={(e) => {
                        if (e.key === Keys.ENTER) {
                          e.preventDefault();
                          handleMUISelectEvent(e);
                        }
                      }}
                      options={groupOptions}
                      openOnFocus
                      forcePopupIcon
                      freeSolo
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          className={labelClasses.formControlRoot}
                          label={res.labelName}
                          slotProps={{
                            inputLabel: {
                              shrink: true,
                            },
                          }}
                        />
                      )}
                    />
                    <img src={OpenIcon} alt="" className="data-fetch-icon" />
                  </div>
                );
              } else
                return (
                  <React.Fragment key={index}>
                    <TextField
                      className="item-ob__entry--textfield"
                      label={res.labelName}
                      slotProps={{
                        inputLabel: { shrink: true },
                      }}
                      value={res.inputName}
                      disabled
                    />
                  </React.Fragment>
                );
            })}
          </div>
        </div>
        <div className="item-ob__entry--block">
          <div className="item-ob__entry--block--details">
            <Title>Enter OB Details</Title>
            <br />
            <Label>OB Qty</Label>
            <Input />
            <Label>Rate</Label>
            <Input />
          </div>
        </div>
        <Button mode="save" />
        <Button mode="clear" />
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
    </>
  );
};

export default ItemIndividualList;
